import * as React from 'react';
import {
  BookIcon,
  BookOpenIcon,
  BoxIcon,
  CircuitBoardIcon,
  CodeIcon,
  CuboidIcon,
  FileBarChartIcon,
  LayoutIcon,
  PlayIcon
} from 'lucide-react';

import { baseUrl, routes } from '@workspace/routes';
import { LinkedInIcon, XIcon } from '@workspace/ui/components/brand-icons';

export const MENU_LINKS = [
  {
    title: 'Product',
    items: [
      {
        title: 'Retrend Platform',
        description: 'All-in-one solution for inventory management',
        icon: <BoxIcon className="size-5 shrink-0" />,
        href: '#',
        external: false
      },
      {
        title: 'Kiosks',
        description: 'Interactive kiosks for customer engagement',
        icon: <PlayIcon className="size-5 shrink-0" />,
        href: '#',
        external: false
      },
      {
        title: 'Employee App',
        description: 'Empower your employees with our mobile app',
        icon: <CircuitBoardIcon className="size-5 shrink-0" />,
        href: '#',
        external: false
      },
      {
        title: 'Plugin',
        description: 'Bring Retrend to your existing platform',
        icon: <LayoutIcon className="size-5 shrink-0" />,
        href: '#',
        external: false
      },
      {
        title: 'SDK',
        description: 'Integrate any Retrend Feature into your applications',
        icon: <FileBarChartIcon className="size-5 shrink-0" />,
        href: '#',
        external: false
      }
    ]
  },
  {
    title: 'Resources',
    items: [
      {
        title: 'Roadmap',
        description: 'See what is coming next',
        icon: <LayoutIcon className="size-5 shrink-0" />,
        href: routes.marketing.Roadmap,
        external: true
      },
      {
        title: 'Docs',
        description: 'Learn how to use our platform',
        icon: <BookOpenIcon className="size-5 shrink-0" />,
        href: routes.marketing.Docs,
        external: false
      },
      {
        title: 'API Reference',
        description: 'Build integrations with our API',
        icon: <CodeIcon className="size-5 shrink-0" />,
        href: `${baseUrl.PublicApi}/docs`,
        external: true
      }
    ]
  },
  {
    title: 'Contact',
    href: routes.marketing.Contact,
    external: false
  },
  {
    title: 'Blog',
    href: routes.marketing.Blog,
    external: false
  },
  {
    title: 'Story',
    href: routes.marketing.Story,
    external: false
  }
];

export const FOOTER_LINKS = [
  {
    title: 'Product',
    links: [
      { name: 'Retrend Platform', href: '#', external: false },
      { name: 'Kiosks', href: '#', external: false },
      { name: 'Employee App', href: '#', external: false },
      { name: 'Plugin', href: '#', external: false },
      { name: 'SDK', href: '#', external: false }
    ]
  },
  {
    title: 'Resources',
    links: [
      { name: 'Contact', href: routes.marketing.Contact, external: false },
      { name: 'Roadmap', href: routes.marketing.Roadmap, external: true },
      { name: 'Docs', href: routes.marketing.Docs, external: false },
      {
        name: 'API Reference',
        href: `${baseUrl.PublicApi}/docs`,
        external: true
      }
    ]
  },
  {
    title: 'About',
    links: [
      { name: 'Story', href: routes.marketing.Story, external: false },
      { name: 'Blog', href: routes.marketing.Blog, external: false }
    ]
  },
  {
    title: 'Legal',
    links: [
      {
        name: 'Terms of Use',
        href: routes.marketing.TermsOfUse,
        external: false
      },
      {
        name: 'Privacy Policy',
        href: routes.marketing.PrivacyPolicy,
        external: false
      },
      {
        name: 'Cookie Policy',
        href: routes.marketing.CookiePolicy,
        external: false
      }
    ]
  }
];

export const SOCIAL_LINKS = [
  {
    name: 'X (formerly Twitter)',
    href: '~/',
    icon: <XIcon className="size-4 shrink-0" />
  },
  {
    name: 'LinkedIn',
    href: '~/',
    icon: <LinkedInIcon className="size-4 shrink-0" />
  }
];

export const DOCS_LINKS = [
  {
    title: 'Getting Started',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Introduction',
        href: '/docs',
        items: []
      },
      {
        title: 'Using the API',
        href: '/docs/api-dependencies',
        items: []
      }
    ]
  },
  {
    title: 'Guides',
    icon: <BookIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Chat API: Initiate, Poll, Terminate',
        href: '/docs/chat-conversation',
        items: []
      },
      {
        title: 'Chat API: Post-Conversation Insights',
        href: '/docs/conversation-post-chat',
        items: []
      },
      {
        title: 'Imports API: Products',
        href: '/docs/product-variant-stock-import',
        items: []
      },
      {
        title: 'Imports API: Recipes',
        href: '/docs/recipe-imports',
        items: []
      },
      {
        title: 'Imports API: Stores',
        href: '/docs/store-import',
        items: []
      },
      {
        title: 'Imports API: Types',
        href: '/docs/broadtype-subtype-import',
        items: []
      },
      {
        title: 'Info API Essentials',
        href: '/docs/info-endpoints',
        items: []
      },
      {
        title: 'Reports API',
        href: '/docs/reporting-api',
        items: []
      },
      {
        title: 'Tagging API',
        href: '/docs/tagging-api',
        items: []
      }
    ]
  }
];
